import component from "./TicketsView";

export default component;
